import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { Bounds } from '@ardoq/graph';
import {
  BLOCKS_VIEW_HEADER_INNER_HEIGHT,
  BLOCKS_VIEW_NODE_LABEL_FONT,
  BLOCKS_VIEW_NODE_LABEL_LINE_HEIGHT,
  BLOCKS_VIEW_NODE_PAD,
} from '../consts';
import { BlocksViewLink, BlocksViewNode } from '../types';
import { isGroup } from '../viewModel$/util';

export const isSyntheticGroup = (node: BlocksViewNode) => {
  return isGroup(node) && (!node.parent || node.id === 'rootLeafGroup');
};

export const isNodeHitVisible = (node: BlocksViewNode) => {
  return !isSyntheticGroup(node);
};

export const isLinkHitVisible = (link: BlocksViewLink) => {
  return link.globalTypeId !== null;
};

export const collapsedGroupHeaderBottom = (cell: Bounds) => {
  if (!cell) {
    return NaN;
  }
  const [, top] = cell;
  return top + 2 * BLOCKS_VIEW_NODE_PAD + BLOCKS_VIEW_HEADER_INNER_HEIGHT;
};
/** @returns the vertical position of the midpoint of buttons in the open group header stripe, such as the expander and url button.  */
export const openGroupHeaderTopTextBaseline = (
  { displayLabel: [mainLabel] }: BlocksViewNode,
  cell: Bounds
) => {
  const [, top] = cell;
  const isMultiLine = mainLabel?.length;
  if (isMultiLine) {
    return top + BLOCKS_VIEW_NODE_PAD + BLOCKS_VIEW_NODE_LABEL_LINE_HEIGHT / 2;
  }
  return top + BLOCKS_VIEW_NODE_PAD + BLOCKS_VIEW_HEADER_INNER_HEIGHT / 2;
};

export const measureNodeLabel = canvasLabelMeasurer(
  BLOCKS_VIEW_NODE_LABEL_FONT
);
